<template>
  <div>
    <div style="display: flex;flex-flow: row; justify-content: center">
    <div class="title">调仲云链电子证据核验</div>
    </div>
    <div style="display: flex;flex-flow: row; justify-content: center">
    <div class="warn-box">
      <div class="warn-box-title">
        <img class="warn-box-title-icon" src="../../assets/img/warning.png" />
        <div class="warn-box-title-content">什么是证据核验</div>
      </div>
      <div class="warn-box-content">hash值是仲裁云链上存证的唯一标识，您可以核验您所持证据是否运用区块链技术已同步存储在仲裁云链。文件hash值是由您下载的电子证据生成，您可以核验电子证据是
        否合法并未被纂改。请在存证报告中复制证据文件对应的hash值，并上传该文件。</div>
    </div>
    </div>
    <div style="width: 100%; display: flex;flex-flow: row; justify-content: center">
      <el-form :model="form" :rules="rules" ref="ruleForm" label-width="160px" class="form-class">
        <el-form-item label="仲裁云链存证hash：" prop="evSn">
          <el-input v-model="form.evSn" placeholder="请输入唯一存证编号或仲裁云链存证hash"></el-input>
        </el-form-item>
        <el-form-item label="上传证据文件：" prop="type">
          <el-select v-model="form.type" placeholder="请选择类型" style="width: 100%">
            <el-option label="文件" value="file"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-upload
                  ref="upload"
                  class="upload-demo"
                  drag
                  action="/"
                  :before-upload="beforeUpload"
                  :on-remove="handleFileRem"
                  :auto-upload="false">
            <img class="upload-icon" src="../../assets/img/file.png" />
            <div class="el-upload__text">请将电子证据文件拖动至此，或<em>点击上传</em><br>大小不超过80M</div>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <div style="display: flex; flex-flow: row">
            <div class="button submit-button" @click="submit">
              <div class="word">查询核验结果</div>
            </div>
            <div class="button cancel-button" @click="cancel">
              <div class="word">取消</div>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <!-- 验证结果对话框 -->
    <div v-cloak v-if="showCheckResult" class="dialog">
      <div class="body">
        <div class="header">
          <div class="header-line"></div>
          <div class="header-title">温馨提示</div>
          <img class="header-icon" src="../../assets/img/close.png" @click="showCheckResult=false"/>
        </div>
        <!-- 核验通过 -->
        <div v-if="checkResult" class="success">
          <div class="result-success">
            <img src="../../assets/img/success.png" class="result-icon"/>
            <div class="result-title">核验通过</div>
          </div>
          <div class="result-success-desc">
            <img src="../../assets/img/right.png" class="result-success-desc-icon" />
            <div class="result-success-desc-word">比对结果一致</div>
          </div>
          <div class="result-success-desc">
            <img src="../../assets/img/right.png" class="result-success-desc-icon" />
            <div class="result-success-desc-word">电子证据已在仲裁云链存证</div>
          </div>
          <div class="result-success-desc">
            <img src="../../assets/img/right.png" class="result-success-desc-icon" />
            <div class="result-success-desc-word">电子数据包完整性校验通过，数据未被篡改</div>
          </div>
          <div class="line"></div>
          <div class="block-info">
            <div class="block-info-line">
              <div class="label">所在区块：</div>
              <div class="label-info">{{blockInfo.blockHash}}</div>
            </div>
            <div class="block-info-line">
              <div class="label">hash：</div>
              <div class="label-info">{{blockInfo.evHash}}</div>
            </div>
            <div class="block-info-line">
              <div class="label">存证类型：</div>
              <div class="label-info">{{blockInfo.evType}}</div>
            </div>
            <div class="block-info-line">
              <div class="label">存证时间：</div>
              <div class="label-info">{{blockInfo.evTime}}</div>
            </div>
            <div class="block-info-line">
              <div class="label">块高：</div>
              <div class="label-info">{{blockInfo.blockHeight}}</div>
            </div>
          </div>
        </div>
        <!-- 核验失败 -->
        <div v-else class="failed">
          <div class="result-failed">
            <img src="../../assets/img/error.png" class="result-icon"/>
            <div class="result-title">核验未通过</div>
          </div>
          <div class="result-failed-desc">核验结果未通过，比对结果不一致</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "verify",
  data() {
    return {
      form: {
          evSn: '',
          type: '文件',
          file: undefined
        },
        rules: {
          evSn: [
            {required: true, message: "仲裁云链存证hash不能为空", trigger: "blur"}
          ],
          type: [
            {required: true, message: "存证类型不能为空", trigger: "change"}
          ]
        },
        checkResult: false,
        showCheckResult: false,
        blockInfo: {
          blockHash: '',
          evHash: '',
          evType: '',
          evTime: '',
          blockHeight: ''
        },
        loading: null
    }
  },
  created() {
      
  },
  methods: {
    handleFileRem() {
      this.form.file = undefined
    },
    beforeUpload(file) {
      if (file) {
        if (file.size / 1024 / 1024 > 80) {
          this.$message({
            type: 'warning',
            message: "文件不能超过80M！"
          })
          this.form.file = undefined
          return
        }
        this.form.file = file
      }
    },
    submit() {
      this.loading = this.$loading({
        lock: true,
        text: "查询中",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let formData = new FormData()
      this.$refs.upload.submit()
      if (!this.form.file) {
        this.loading.close();
        return
      }
      formData.append('file', this.form.file)
      formData.append('evSn', this.form.evSn)
      this.$api.api.fileEvVerify(formData).then(response => {
        if (response.code === 200) {
          this.loading.close();
          if (response.data) {
            this.blockInfo = response.data
            this.showCheckResult = true
            this.checkResult = true
          } else {
            this.showCheckResult = true
            this.checkResult = false
          }
          this.$refs.upload.clearFiles();
          this.cancel()
        }  
      });
    },
    cancel() {
      this.form = {
        evSn: '',
        type: '文件',
        file: undefined
      }
    }
  }
}
</script>

<style lang="less">
body {
    border: 1px solid #F1F1F1;
}
.title {
    font-size: 1.8vw;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin-top: 3vw;
    width: 1091px;
}
.warn-box {
    width: 1091px;
    height: 99px;
    background: #F5E8D8;
    border: 1px solid #F5E8D8;
    border-radius: 6px;
    margin-top: 21px;
}
.warn-box-title {
    display: flex;
    flex-flow: row;
    margin-top: 20px;
}
.warn-box-title-icon {
    width: 22px;
    height: 18px;
    margin-left: 20px;
    margin-right: 9px;
}
.warn-box-title-content {
    font-size: 15px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
}
.warn-box-content {
    font-size: 13px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin-top: 12px;
    margin-left: 51px;
    margin-right: 45px;
}
.form-class {
    width: 500px;
    margin-top: 47px;
}
.el-upload__text {
    font-size: 13px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
}
.upload-icon {
    width: 47px;
    height: 41px;
}
.button {
    width: 128px;
    height: 38px;
    border-radius: 2px;
    text-align: center;
    cursor: pointer;
}
.submit-button {
    background: #FF5C5C;
}
.cancel-button {
    opacity: 0.4;
    border: 1px solid #C5A054;
    border-radius: 2px;
    margin-left: 10px;
}
.submit-button .word {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 38px;
    opacity: 0.8;
}
.cancel-button .word {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 38px;
    opacity: 0.8;
}
.dialog {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    left: 0;
    top: 0;
    z-index: 99;
}
.dialog .body {
    width: 580px;
    background: #FFFFFF;
    position: fixed;
    z-index: 999;
    left: 50%;
    top: 50%;
    margin-left: -290px;
    margin-top: -197px;
}
.dialog .body .header {
    width: 580px;
    height: 32px;
    background: linear-gradient(0deg, #F2F2F2, #FFFFFF);
    display: flex;
    flex-flow: row;
    align-items: center;
}

.dialog .body .header-line {
    width: 3px;
    height: 14px;
    background: #2080D0;
    border-radius: 2px;
    margin-left: 21px;
    margin-right: 10px;
}

.dialog .body .header-icon {
    width: 18px;
    height: 18px;
    margin-left: auto;
    margin-right: 12px;
    cursor: pointer;
}

.dialog .body .header-title {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #0D0409;
    line-height: 32px;
}

.dialog .body .success {
    margin-top: 43px;
    margin-bottom: 63px;
}

.dialog .body .failed {
    margin-top: 43px;
    margin-bottom: 84px;
}

.dialog .body .result-failed {
    display: flex;
    flex-flow: row;
    margin-left: 131px;
}

.dialog .body .result-success {
    display: flex;
    flex-flow: row;
    margin-left: 100px;
}

.dialog .body .result-icon {
    width: 24px;
    height: 24px;
    margin-right: 11px;
}

.dialog .body .result-title {
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
}

.dialog .body .result-failed-desc {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin-top: 15px;
    margin-left: 166px;
}

.dialog .body .result-success-desc {
    display: flex;
    flex-flow: row;
    margin-left: 136px;
    margin-top: 15px;
}


.dialog .body .result-success-desc-icon {
    width: 16px;
    height: 18px;
    margin-right: 8px;
}

.dialog .body .result-success-desc-word {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
}

.dialog .body .line {
    width: 347px;
    height: 1px;
    background: #EAEAEA;
    margin-left: 136px;
    margin-top: 18px;
}

.dialog .body .block-info {
    margin-left: 136px;
    margin-top: 18px;
}

.dialog .body .block-info-line {
    display: flex;
    flex-flow: row;
    font-size: 13px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
}

.dialog .body .label {
    min-width: 70px;
}

.dialog .body .label-info {
    word-break: break-all;
    word-wrap: normal;
    white-space: normal;
    margin-right: 20px;
}

.upload-icon {
    margin-top: 36px;
}
</style>
